<template>
    <div style="display:flex;">
        <section style="width:30%; padding-right:24px;">
            <img :src="imgSource" style="width:100%; height:auto;">
        </section>
        <section>
            <h3 v-html="styleAndSkus['brand']"></h3>
            <p>{{ styleAndSkus['short_desc'] }}</p>
            <span style="color:#cd1b00;font-weight:bold;">{{ styleAndSkus['prod_key'] }}</span>
            <p><strong>PRICE LEVEL: </strong>{{ custInfo['price_level'] }}</p>
            <p><strong>PRICE LIST: </strong>{{ styleAndSkus['price_list_start'] }}</p>
            <p><strong>EFFECTIVE DATES: </strong>{{ styleAndSkus['price_list_start'] }} - {{ styleAndSkus['price_list_end'] }}</p>
            <p><strong>6M SALES: </strong>${{ submission['sales_6m'] }}</p>
            <p><strong>12M SALES: </strong>${{ submission['sales_12m'] }}</p>
            <p v-if="styleAndSkus['coo'] == 'China'" style="color:#cd1b00;"><strong>COUNTRY OF ORIGIN: </strong>{{ styleAndSkus['coo'] }}</p>
            <p v-else><strong>COUNTRY OF ORIGIN: </strong>{{ styleAndSkus['coo'] }}</p>
        </section>
    </div>
</template>

<script>
export default {
    props: ['submission','styleAndSkus', 'imgSource', 'custInfo']
}
</script>
